import template from './views/extended-list.tpl.html';
import toolsetTemplate from '../../pages/guestlists/views/pages/rsvps/toolsets/rsvp-list-stats.tpl.html';

export default {
    slug: 'rsvps',
    type: 'rsvp',
    title: 'RSVPs',
    visible: [
        'booking_number',
        'contact.customer_number',
        'contact.full_name',
        'status',
        'pax_planned',
        'pax_guest',
        'code',
        'contact.sex',
        'contact.first_name',
        'contact.last_name',
        'contact.preferred_email',
        'last_message_state',
        'created_at',
        'updated_at'
    ],
    listview: 'RsvpListView',
    locales: ['common'],
    emptyListActions: [
        'quick-add-contact',
        'import-rsvps'
    ],
    toolsetTemplate,
    extendedListView: true,
    extendedListViewTemplate: template,
    extendedListController: 'RsvpsExtendedListViewCtrl',
    view: {
        mode: 'tableview',
        hideGuests: true
    },
    permanentFields: [
        'id',
        'contact.id',
        'guestlist.id',
        'has_child',
        'has_parent',
        'contact.blacklist'
    ],
    templates: {
        seatplan_elements(row) {
            let out = '',
                first = true;
            _.each(row.seatplan_elements, (element) => {
                if (!first) {
                    out += '<br/>';
                }
                out += element.title + ' (';
                if (element.custom_label) {
                    out += 'Custom Label: ' + element.custom_label + ', ';
                }
                out += 'pax: ' + element.pax + ')';
                first = false;
            });
            return out;
        },
        booked_objects(row) {
            let out = '',
                first = true;
            _.each(row.booked_objects, (option) => {
                if (!first) {
                    out += '<br/>';
                }
                out += option.option.label;
                first = false;
            });
            return out;
        },
        'contact.customer_number'(row) {
            return (row.contact.blacklist) ? '<span class="text-red">' + row.contact.customer_number + '</span>' : row.contact.customer_number;
        },
        'contact.full_name'(row) {
            return (row.contact.blacklist) ? '<span class="text-red">' + row.contact.full_name + (row.has_child ? ' <i class="fal fa-users"></i>' : '') + '</span>' : row.contact.full_name + (row.has_child ? ' <i class="fal fa-users"></i>' : '');
        },
        'contact.company_name'(row) {
            return (row.contact.blacklist) ? '<span class="text-red">' + row.contact.company_name + '</span>' : row.contact.company_name;
        },
        consumption(row) {
            return parseFloat(row.consumption ? row.consumption : 0).toFixed(2) + ' €';
        },
        consumption_per_person(row) {
            return parseFloat(row.consumption_per_person ? row.consumption_per_person : 0).toFixed(2) + ' €';
        },
        previous_booking_consumption(row) {
            return parseFloat(row.previous_booking_consumption ? row.previous_booking_consumption : 0).toFixed(2) + ' €';
        },
        previous_booking_consumption_per_person(row) {
            return parseFloat(row.previous_booking_consumption_per_person ? row.previous_booking_consumption_per_person : 0).toFixed(2) + ' €';
        },
        consumption_tip(row) {
            return parseFloat(row.consumption_tip ? row.consumption_tip : 0).toFixed(2) + ' €';
        },
        consumption_tip_per_person(row) {
            return parseFloat(row.consumption_tip_per_person ? row.consumption_tip_per_person : 0).toFixed(2) + ' €';
        }
    },
    columns: [
        {
            key: 'code',
            main: true
        },
        {
            key: 'pax_planned',
            main: true,
        },
        {
            key: 'status',
            main: true,
        },
        {
            key: 'contact.full_name',
            main: true,
        },
        {
            key: 'contact.email',
            main: true,
        },
        {
            key: 'created_at',
            main: true,
        },
        {
            key: 'updated_at',
            main: true,
        },
    ],
    actions: {},
    copyColumns: [
        'code',
        'contact.code',
        'contact.full_name',
        'contact.email',
        'contact.business_email',
        'contact.preferred_email',
        'contact.cc_email',
        'contact.web',
        'contact.business_web',
        'last_message_subject',
        'last_message_state_information',
        'companion_group'
    ],
    tooltipColumns: [
        'parent_rsvp.company_name',
        'parent_rsvp.full_name',
        'last_message_state_information',
        'last_message_subject',
        'contact.email',
        'contact.business_email',
        'contact.full_name',
        'contact.company_name',
        'contact.cc_email',
        'contact.comment',
        'contact.business_web',
        'contact.web',
        'contact.business_web',
        'contact.blacklist_reason',
        'contact.last_invoice.address',
        'contact.last_invoice.subject',
        'contact.last_invoice.text_1',
        'contact.last_invoice.text_3',
        'contact.last_invoice.text_3',
        'contact.custom_1',
        'contact.custom_2',
        'contact.custom_3',
        'contact.custom_4',
        'contact.custom_5',
        'contact.custom_6',
        'contact.custom_7',
        'contact.custom_8',
        'contact.custom_9',
        'contact.custom_10',
        'contact.custom_11',
        'contact.custom_12',
        'contact.custom_13',
        'contact.custom_14',
        'contact.custom_15',
        'contact.custom_16',
        'contact.custom_17',
        'contact.custom_18',
        'contact.custom_19',
        'contact.custom_10',
        'contact.custom_21',
        'contact.custom_22',
        'contact.custom_23',
        'contact.custom_24',
        'contact.custom_25',
        'contact.custom_26',
        'contact.custom_27',
        'contact.custom_28',
        'contact.custom_29',
        'contact.custom_30',
        'contact.custom_31',
        'contact.custom_32',
        'contact.custom_33',
        'contact.custom_34',
        'contact.custom_35',
        'contact.custom_36',
        'contact.custom_37',
        'contact.custom_38',
        'contact.custom_39',
        'contact.custom_40',
        'custom_1',
        'custom_2',
        'custom_3',
        'custom_4',
        'custom_5',
        'custom_6',
        'custom_7',
        'custom_8',
        'custom_9',
        'custom_10',
        'custom_11',
        'custom_12',
        'custom_13',
        'custom_14',
        'custom_15',
        'custom_16',
        'custom_17',
        'custom_18',
        'custom_19',
        'custom_10',
        'custom_21',
        'custom_22',
        'custom_23',
        'custom_24',
        'custom_25',
        'custom_26',
        'custom_27',
        'custom_28',
        'custom_29',
        'custom_30',
        'custom_31',
        'custom_32',
        'custom_33',
        'custom_34',
        'custom_35',
        'custom_36',
        'custom_37',
        'custom_38',
        'custom_39',
        'custom_40'
    ],
    alertOverrides: {
        bulkArchive: {
            message: 'sweetalerts.archiving_rsvps_confirmation_message'
        },
        bulkDelete: {
            message: 'sweetalerts.deleting_rsvps_confirmation_message'
        }
    },
    includeDeletedGuestlists: false,
    extendFilterRequestInformation: (state, store) => ({
        includeDeletedGuestlists: store.state.includeDeletedGuestlists
    })
}

// @todo new alert, need Thalli's support



// WEBPACK FOOTER //
// ./src/app/store/rsvps/state.js